import { render, staticRenderFns } from "./PreFestivalView.vue?vue&type=template&id=5bfadc3b&"
import script from "./PreFestivalView.vue?vue&type=script&lang=ts&"
export * from "./PreFestivalView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports